"use strict";

exports.__esModule = true;
exports.isDef = isDef;
function isDef(val) {
  return val !== undefined && val !== null;
}


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/utils/shared.js
// module id = 74
// module chunks = 0